// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__28qAC","info":"PatientInfo_info__1yixG"};